import { authConfig } from "../apiConfig";

export const add_holiday = async (data) => {
    try {
        const response = await authConfig.post(`addHolidays`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const update_holiday = async (data) => {
    try {
        const response = await authConfig.post(`updateHoliday`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response?.data;
    } catch (error) {
        throw error;
    }
};

export const delete_holiday = async (data) => {
    try {
        const response = await authConfig.post(`deleteHoliday`, data, { headers: { "Content-Type": "multipart/form-data" } });
        return response?.data;
    } catch (error) {
        throw error;
    }
};
export const get_All_holidays = async (data) => {
    try {
        const response = await authConfig.post(`getAllholidays`, data);
        return response.data;
    } catch (error) {
        throw error;
    }
};